import UpdateAuthPage from "./UpdateAuthPage";

export default UpdateAuthPage;